import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaTachometerAlt,
  FaSignOutAlt,
  FaChevronDown, 
} from "react-icons/fa";
import { MdLocalPharmacy } from "react-icons/md";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./style.css";

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  // List of submenu paths
  const documentSubmenuLinks = [
    { to: "/document", label: "Document Verification Form" },
    { to: "/provisional-certificate", label: "Provisional Certificate" },
    { to: "/migration-certificate", label: "Migration Certificate" },
    { to: "/bonafide-certificate", label: "Bonafide Certificate" },
    { to: "/character-certificate", label: "Character Certificate" },
    { to: "/duplicate-certificate", label: "Duplicate Certificate" },
    { to: "/internship-permission", label: "Internship Permission" },
    { to: "/transcript-certificate", label: "Consolidated Transcript Certificate" },
    { to: "/course-completion", label: "Course Completion Certificate" },
    { to: "/cgpa-percentage", label: "CGPA To Percentage Certificate" },
  ];

  // Check if user is on any document page
  const isDocumentSubmenuActive = documentSubmenuLinks.some(
    (item) => item.to === location.pathname
  );

  useEffect(() => {
    // Jab bhi user kisi submenu page pe jaye, submenu open ho jaye
    if (isDocumentSubmenuActive) {
      setIsSubMenuOpen(true);
    }
  }, [location.pathname]);

  const toggleSubMenu = () => {
    // Manually open/close karne ke liye
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  return (
    <aside className={`dashboard-sidebar ${isSidebarOpen ? "open" : "collapsed"}`}>
      <div className="sidebar-header">
        <button className="toggle-btn" onClick={toggleSidebar}>
          <FaBars />
        </button>
        {isSidebarOpen && <span className="sidebar-title">SGTU Dashboard</span>}
      </div>

      <div className="sidebar-menu">
        <Link
          to="/dashboard"
          className={`sidebar-link ${location.pathname === "/dashboard" ? "active" : ""}`}
        >
          <FaTachometerAlt />
          {isSidebarOpen && "Dashboard"}
        </Link>

        <div
          className={`sidebar-link ${isSubMenuOpen ? "submenu-open" : ""}`}
          onClick={toggleSubMenu}
        >
          <FaChevronDown style={{ transform: isSubMenuOpen ? "rotate(180deg)" : "none" }} />
          {isSidebarOpen && "Documents"}
        </div>

        {isSubMenuOpen && isSidebarOpen && (
          <div className="submenu">
            {documentSubmenuLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`submenu-link ${location.pathname === item.to ? "active" : ""}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}

        {/* <Link
          to="/pharmacyData"
          className={`sidebar-link ${location.pathname === "/pharmacyData" ? "active" : ""}`}
        >
          <MdLocalPharmacy />
          {isSidebarOpen && "Pharmacy"}
        </Link> */}

        <div className="sidebar-link logout-btn" onClick={handleLogout}>
          <FaSignOutAlt />
          {isSidebarOpen && "Logout"}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;